import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdvancedFilterContainer from './../Advanced'
import EducationMiddleware from './../../../modules/education/middleware'
import AdoptionActions from './../../../modules/adoption/actions'
import TeacherMiddleware from './../../../modules/teachers/middleware'
import FilterAdoptions from './../../../components/Filter/FilterAdoptions'
import AdoptionsMiddleware from './../../../modules/adoption/middleware'
import { addNotification as notify } from 'reapop'
import {paramsWarningNotify} from '../../../utils/notifyConfig'

const mapStateToProps = ({education, teachers, units, adoption}) => ({
  subjects: education.subjects,
  teachers: teachers,
  currentUnit: units.currentItem,
  onuFilter: adoption.filter.onuGroups
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchAdoptions: () => AdoptionsMiddleware.fetchAdoptions(),
    fetchSubjects: (page) => EducationMiddleware.fetchSubjects(),
    fetchTeachers: (page) => TeacherMiddleware.fetchTeachers(),
    advancedChangeFilter: (type, currentIds) => AdoptionActions.changeAdvancedFilter({type: type, activeIds: currentIds}),
    changeFilter: (type, currentIds) => AdoptionsMiddleware.changeFilter(type, currentIds),
    notify: () => (notify({
      ...paramsWarningNotify,
      message: 'Por favor, selecione uma escola.',
      status: 400}))
  }, dispatch)
}

class FilterAdoptionsContainer extends Component {
  componentDidMount () {
    const { fetchSubjects, fetchTeachers, currentUnit } = this.props
    fetchSubjects()
    if (currentUnit.item) fetchTeachers()
  }

  componentDidUpdate (prevProps) {
    const { currentUnit, fetchTeachers } = this.props
    if (currentUnit.item === null && prevProps.currentUnit.item !== null) this.clearFilters()
    if (currentUnit.item && currentUnit.item !== prevProps.currentUnit.item) fetchTeachers()
  }

  checkCurrentUnit = () => {
    const { currentUnit, notify } = this.props
    if (!currentUnit.item) {
      notify()
      document.querySelector('.nav .nav-left .Select input').focus()
    }
  }

  clearFilters = () => {
    this.adoptionsFilter.clearFitler()
  }

  render () {
    const {
      subjects,
      teachers,
      changeFilter,
      fetchAdoptions,
      currentUnit,
      onuFilter
    } = this.props

    return (
      <div>
        <FilterAdoptions
          fetchAdoptions={fetchAdoptions}
          subjects={subjects}
          teachers={teachers}
          changeFilter={changeFilter}
          checkUnit={this.checkCurrentUnit}
          disabled={currentUnit.item === null || currentUnit.item === undefined}
          ref={(element) => { this.adoptionsFilter = element }}
        />
        <AdvancedFilterContainer
          changeHandler={changeFilter}
          onuFilterDependence={onuFilter}
          ref={(element) => { this.advFilter = element }}
          clearFilters={currentUnit.item === null}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterAdoptionsContainer)



// WEBPACK FOOTER //
// ./src/containers/FilterContainers/Adoptions/index.js